import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export function getCheckInTalkingPointsApi({ orgId }) {
  const url = endpoints.checkIn.talkingPointQuestions(orgId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function addCheckInTalkingPointsApi({ orgId, data }) {
  const url = endpoints.checkIn.talkingPointQuestions(orgId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: data,
  });
}

export function updateCheckInTalkingPointsApi({ orgId, uuid, data }) {
  const url = `${endpoints.checkIn.talkingPointQuestions(orgId)}/${uuid}`;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: data,
  });
}

export function deleteCheckInTalkingPointApi({ orgId, uuid }) {
  const url = `${endpoints.checkIn.talkingPointQuestions(orgId)}/${uuid}`;
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
}

export function getTalkingPointCommnentsApi({ parentId, startTS, endTS, limit, offset, questionId, scrollType }) {
  const url = endpoints.checkIn.talkingPointComments;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      parentId,
      startTS,
      endTS,
      limit,
      offset,
      questionId,
      scrollType,
    },
  });
}

export function getGoalRecurrenceDetailsApi({ teamId }) {
  const url = endpoints.checkIn.fetchGoalRecurrence;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: { teamId },
  });
}

export function updateGoalRecurrenceDetailsApi({ teamId, recurrenceValue, recurrenceType }) {
  const url = endpoints.checkIn.updateGoalRecurrence;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      teamId,
      recurrenceValue,
      recurrenceType,
    },
  });
}
